<template>
  <div class="common-home-content">
    <div class="survey-line"></div>
    <div
      class="survey-content"
      v-for="(survey, index) in surveys"
      :key="index"
      v-show="show_index == index">
      <div class="space_pl space_pr" style="margin-top:12px;" v-if="index == 0">
        <p class="survey-answer-tip">温馨提示：</p>
        <p class="survey-answer-tip">·急性病以当下状况为准，慢性病以近三天症状为准</p>
        <p class="survey-answer-tip">·请认真填写以便医生准确诊疗</p>
      </div>
      <p class="survey-title">{{survey.name}}</p>
      <ul class="questions-ul">
        <li
          v-for="(question, question_index) in survey.questions"
          :key="question_index"
        >
          <p class="question-title space_pl space_pr">{{question_index+1}}.{{question.content}}{{getQuestionType(question.type)}}</p>
          <div class="question-textarea space_pl space_pr" v-if="question.type == 3">
            <van-field
              v-model="question.value"
              rows="2"
              autosize
              :readonly="!is_patient"
              type="textarea"
              class="field-textarea"
              @input="handleTextarea($event, index, question_index)"
            />
          </div>
          <ul class="options-ul space_pl space_pr clearfix" v-else>
            <li
              class="fl"
              v-for="(option, option_index) in question.options"
              :key="option_index"
              :class="option.checked?'actived':''"
              @click="handleSelectOption(index, question_index, option_index, question.type)"
            >{{option.content}}</li>
          </ul>
        </li>
      </ul>
      <div v-if="is_patient">
        <div class="answer-btns" style="padding-left:84px;padding-right:84px;" v-if="surveys.length == 1">
          <button @click="handleSubmitSurvey">提交</button>
        </div>
        <div class="answer-btns" v-else>
          <button @click="handleChangeSurvey(index+1)" v-if="index == 0">下一步</button>
          <div class="btns-content clearfix" v-else>
            <div class="left fl">
              <button @click="handleChangeSurvey(index-1)" class="other-button">上一步</button>
            </div>
            <div class="right fr">
              <button @click="handleSubmitSurvey" v-if="(index+1) == surveys.length">提交</button>
              <button @click="handleChangeSurvey(index+1)" v-else>下一步</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="is_doctor">
        <div class="answer-btns" v-if="surveys.length > 1">
          <button @click="handleChangeSurvey(index+1)" v-if="index == 0">下一步</button>
          <div class="btns-content clearfix" v-else>
            <div class="left fl" :class="(index+1) == surveys.length?'full':''">
              <button @click="handleChangeSurvey(index-1)" class="other-button">上一步</button>
            </div>
            <div class="right fr" v-if="(index+1) != surveys.length">
              <button @click="handleChangeSurvey(index+1)">下一步</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {_} from 'vue-underscore';
import http from '../../util/heraApiConfig'
import {deviceType} from '../../util/deviceType'
import familyBaApiConfig from '../../util/familyBaApiConfig'
import $ from 'jquery'
export default {
  data() {
    return {
      show: false,
      title: '填写问诊单',
      show_index: 0,
      surveys: [],
      doctor_id: 1,
      user_id: 14,
      survey_id: 12,
      archive_id: 1,
      is_doctor: deviceType.isDoctor,
      is_patient: deviceType.isPatient,
      survey_name: '',
      questions: [],
      token: '',
      survey_value: '',
      is_mini:'',
      is_baoan:'',
      doctor_user_id:0,
      platform_type:1
    };
  },
  metaInfo(){
    return {title: this.title};
  },
  created() {
    if(this.$route.query.survey_id){
      this.survey_id = this.$route.query.survey_id;
    }
    if(this.$route.query.user_id){
      this.user_id = this.$route.query.user_id;
    }
    if(this.$route.query.doctor_id){
      this.doctor_id = this.$route.query.doctor_id;
    }
    if(this.$route.query.archive_id){
      this.archive_id = this.$route.query.archive_id;
    }
    if(this.$route.query.doctor_user_id){
      this.doctor_user_id = this.$route.query.doctor_user_id;
    }
    if(this.$route.query.is_mini){
      this.is_patient = true
      this.is_mini = true
    }
    if(this.$route.query.is_baoan){
      this.is_patient = true
      this.is_baoan = true
    }
    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if(this.isApp == "IOS"){
      bridge.callHandler("getUserInfo", "", (response) => {
        this.token = response.token;
        this.platform_type = response.platform_type;
      });
    }else  if (this.isApp == "android") {
      var user_info = this.$appUtils.appData();
      if(user_info){
        this.token = user_info.token;
        this.platform_type = user_info.platform_type;
      }
    }else if(this.$route.query.is_mini){
      this.token = this.$route.query.token
    }else if(this.$route.query.is_baoan){
      console.log(this.$route.query)
      this.token = this.$route.query.token
    }
    setTimeout(()=>{
      this.getDate();
    }, 1000);
    window.appTrBtnClick = ()=> this.editSurvey();
    window.appBack = ()=> this.pageback();
  },

  mounted() {
    // document.addEventListener('UniAppJSBridgeReady', function() {
    //   uni.reLaunch({
    //     url: "/pageChat/chatIM/chatIM",
    //   });
    // });
  },
  methods: {
    getQuestionType(id){
      if(id == 2){
        return '（多选）';
      }else{
        return '';
      }
    },
    getDate() {
      let that = this;
      let params = {
          doctor_id: that.doctor_id,
          user_id: that.user_id
      }
      http.get("/surveys/"+that.survey_id+"/answer"+'?platform_type=' +this.platform_type, {params: params,
        headers: {
            "Authorization": that.token
        }
      }).then(function(res) {
          if(res.data.status_code == 200){
            that.surveys = res.data.data;
            that.show = true;
          }else if(res.data.status_code == 10006){
            that.$router.push({ path: "/surveydetail", query: {
                survey_id: that.survey_id,
                user_id: that.user_id,
                doctor_id: that.doctor_id,
                archive_id: that.archive_id,
                ...that.$route.query
              }});
          }
      });
    },
    handleSelectOption(index, index2, index3, type){
      console.log(this.is_patient,type)
      if(this.is_patient){
        let options = this.surveys[index]['questions'][index2]['options'];
        if(type == 1){
          for(let i = 0; i < options.length; i++){
            options[i]['checked'] = false;
          }
          options[index3]['checked'] = true;
        }else{
          options[index3]['checked'] = !options[index3]['checked'];
        }
        this.$forceUpdate();
      }
    },
    handleTextarea(e, index, index2){
      if(this.is_patient){
        this.surveys[index]['questions'][index2]['value'] = e;
        this.$forceUpdate();
      }
    },
    handleChangeSurvey(index){
      this.show_index = index;
      $(window).scrollTop(0);
    },
    handleSubmitSurvey(){
      let that = this;
      let answers = [];
      let surveys = that.surveys;
      for(let i = 0; i < surveys.length; i++){
        let obj = {}
        obj['sheet_id'] = surveys[i]['sheet_id'];
        obj['questions'] = []
        let questions = surveys[i]['questions'];
        for(let j = 0; j < questions.length; j++){
          let question = {}
          question['question_id'] = questions[j]['question_id'];
          question['type'] = questions[j]['type'];
          if(question['type'] == 3 && questions[j]['value']){
            question['options'] = [{'content': questions[j]['value']}]
            obj['questions'].push(question)
          }else{
            let options = []
            for(let k = 0; k < questions[j]['options'].length; k++){
              if(questions[j]['options'][k]['checked']){
                options.push({'option_id': questions[j]['options'][k]['option_id']});
              }
            }
            if(options.length > 0){
              question['options'] = options;
              obj['questions'].push(question)
            }
          }
        }
        answers.push(obj)
      }
      console.log(answers)
      let params = {
        user_id: that.user_id,
        survey_id: that.survey_id,
        archive_id: that.archive_id,
        answers: JSON.stringify(answers)
      }
      console.log(params)
      http.post("/surveys/answers"+'?platform_type=' +this.platform_type, params ,{headers: {"Authorization": that.token }
      }).then(function(res) {
        let bridge = window.WebViewJavascriptBridge;
          if(res.data.status_code == 200){
            if(that.isApp == 'android'){
              that.$appUtils.appSurveySubmit({
                'survey_id': that.survey_id,
                'user_id': that.user_id,
                'doctor_id': that.doctor_id,
                'archive_id': that.archive_id
              });
            }else if(that.isApp == 'IOS'){
              bridge.callHandler('surveySubmit',{     'survey_id':that.survey_id,
                'user_id':that.user_id,
                'doctor_id':that.doctor_id,
                'archive_id': that.archive_id},(response) => {
              })
            }else if(that.is_mini == true){
              //如果是小程序则返回用户id,医生id,医生用户id,
              uni.reLaunch({
                url: "/pageChat/chatIM/chatIM?survey_id="+that.survey_id+"&archive_id="+that.archive_id+"&user_id="+that.user_id+"&doctor_id="+that.doctor_id+"&doctor_user_id="+that.doctor_user_id+"&sendSurvey=true",
              });
            }else if(that.is_baoan){
              window.location.href = familyBaApiConfig+"/chatIM?user_id="
                +that.$route.query.user_id+"&doctor_id="+that.$route.query.doctor_id+"&doctor_user_id="+that.$route.query.doctor_user_id+"&survey_id="+that.$route.query.survey_id+"&archive_id="+that.$route.query.archive_id+"&sendSurvey=true"

            }
          }else {
            alert(res.data.msg)
          }
      });
    },
    pageback(){
        return null;
    }
  },
};
</script>
<style lang="scss" scoped>
.new-build-survey{
  width: 32px;
  line-break: 16px;
  font-size:16px;
  font-family: PingFang-SC-Bold;
  font-weight:bold;
  color:rgba(172,75,56,1);
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 14px;
}
.common-home-content-pb{
  padding-bottom: 52px;
}
.survey-line{
  width: 100%;
  height: 1px;
}
.survey-content{
  width: 100%;
  box-sizing: border-box;
  .survey-answer-tip{
    font-size:15px;
    font-family:PingFang-SC-Medium,PingFang-SC;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:20px;
  }
  .survey-title{
    margin-top: 30px;
    margin-bottom: 21px;
    font-size:20px;
    font-family:PingFang-SC-Bold,PingFang-SC;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:29px;
    text-align: center;
    position: relative;
  }
  .survey-title::after{
    display: block;
    content: '';
    width:37px;
    height:4px;
    background:rgba(172,75,56,1);
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -2px;
  }
  .questions-ul{
    width: 100%;
    box-sizing: border-box;
    padding-bottom: 20px;
    & > li{
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 15px;
      .question-title{
        padding-top: 11px;
        padding-bottom: 11px;
        font-size:16px;
        font-family:PingFang-SC-Bold,PingFang-SC;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:22px;
        text-align: left;
        background:rgba(248,248,248,1);
      }
      .question-textarea{
        margin-top: 15px;
        width: 100%;
        box-sizing: border-box;
        .field-textarea{
          font-family:PingFang-SC-Medium,PingFang-SC;
          font-weight:500;
          color:rgba(51,51,51,1);
          border-radius:8px;
          border:1px solid rgba(153,153,153,1);
        }
      }
      .options-ul{
        width: 100%;
        box-sizing: border-box;
        & > li{
          margin-top: 10px;
          margin-right: 10px;
          display: inline-block;
          box-sizing: border-box;
          border: 1px solid #E6E6E6;
          padding: 5px 10px;
          line-height: 14px;
          font-size:14px;
          font-family:PingFang-SC-Medium;
          font-weight:500;
          color:rgba(102,102,102,1);
          border-radius:13px;
        }
        .actived{
          color:rgba(255,255,255,1);
          background:#AC4B38;
          border:1px solid #AC4B38;
        }
      }
    }
    & > li:last-child{
      margin-bottom: 0;
    }
  }
}
.answer-btns{
  display: block;
  width: 100%;
  box-sizing: border-box;
  margin: 10px auto 0;
  padding-bottom: 34px;
  padding-left: 50px;
  padding-right: 50px;
  .btns-content{
    width: 100%;
    box-sizing: border-box;
    .left{
      width: 50%;
      box-sizing: border-box;
      padding-right: 18px;
    }
    .right{
      width: 50%;
      box-sizing: border-box;
      padding-left: 18px;
    }
    .full{
      width: 100%;
      padding-left: 0;
    }
  }
  button{
    width: 100%;
    line-height: 38px;
    font-size:18px;
    font-family:PingFang-SC-Bold,PingFang-SC;
    font-weight:bold;
    color:rgba(255,255,255,1);
    border:1px solid rgba(172,75,56,1);
    background:rgba(172,75,56,1);
    border-radius:20px;
  }
  .other-button{
    color:rgba(172,75,56,1);
    background:rgba(255,255,255,1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/surveryanswer.vue